"use client";

import { MessageCircle } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function WhatsAppButton() {
  return <div className="fixed bottom-6 right-6 z-50">
      <Link to="https://wa.me/573001234567?text=Hola,%20me%20gustaría%20solicitar%20un%20diagnóstico%20gratuito" newTab className="block">
        <Button size="icon" className="size-14 rounded-full bg-[hsl(142,70%,49%)] text-white shadow-strong hover:bg-[hsl(142,70%,39%)] hover:shadow-[0_12px_24px_rgba(0,0,0,0.16)] hover:-translate-y-0.5 focus-visible:ring-[hsl(142,70%,49%)]/60 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] animate-[pulse_0.8s_ease-in-out_infinite]" aria-label="Contactar por WhatsApp">
          <MessageCircle className="size-6" />
        </Button>
      </Link>
    </div>;
}